const { config } = require("../../../package.json");

const alias = (() => {
    return config.serviceProfile ? `/${config.serviceProfile}` : "";
})();

function getApiEndpoint() {
    return (
        (config["isCloudDeployment"] &&
            `https://api-eu.revrec.devcb.in${alias}`) ||
        "http://localhost:3001"
    );
}

const baseRedirectUrl = (() => {
    return "https://app-eu.revrec.devcb.in";
})();

const baseReportUrl = (() => {
    return "https://reports-eu.revrec.devcb.in";
})();

export default {
    microstrategy: {
        mstrWebUrl: `${baseReportUrl}/MicroStrategy/servlet/`,
        project: "QA_RL",
        server: "mstr-is.dev-eu.revrec.local"
    },
    hotGlue: {
        env_id: "dev-eu.hotglue.revrec.devcb.in"
    },
    AWS: {
        API: {
            endpoints: [
                {
                    name: "revlock_api",
                    endpoint: getApiEndpoint()
                },
                {
                    name: "revlock_public_api",
                    endpoint: getApiEndpoint(),
                    custom_header: async () => {
                        return {
                            "x-api-key":
                                "Ojh2e1JrIF1ECY0dRdEpFaecntRO89M58RpWzgwR"
                        };
                    }
                }
            ]
        },
        Auth: {
            identityPoolId: "eu-central-1:1df8e605-1f8a-4b98-9abe-c617d9ee7796",
            region: "eu-central-1",
            userPoolId: "eu-central-1_OnQo76XEM",
            userPoolWebClientId: "1759k6ep2mondsht8edk434isd",
            mandatorySignIn: true
        },
        Storage: {
            bucket: "cb-revrec-dev-eu-c1-userfiles",
            region: "eu-central-1",
            hotglueBucket: "cb-revrec-dev-eu-c1-hotgluefiles"
        },
        Analytics: {
            disabled: true
        },
        oauth: {
            domain: "auth-eu.revrec.devcb.in",
            clientId:
                "1092057117597-1nosea2ifka99fshkiqo4a4iajmjucq4.apps.googleusercontent.com",
            redirectSignOut: `${baseRedirectUrl}/signout`,
            redirectSignIn: `${baseRedirectUrl}/`,
            scope: ["email", "profile", "openid"],
            responseType: "code"
        }
    },
    analytics: {
        trackingId: "UA-127158128-3",
        debug: true
    },
    keycloakConfig: {
        url: "https://idp-broker.devcb.in/",
        redirectUri: `https://qa-${config.serviceProfile}-sso.stagingcb.com/`,
        realm: "master",
        clientId: "revrec-app",
        idpHint: "revrec-idp",
        redirectSignoutUri: `https://qa.auth.rev-lock.com/logout?client_id=6f50lh83rprtp3pl1sof5edsdn&logout_uri=https%3A%2F%2Fqa-${config.serviceProfile}-sso.stagingcb.com%2F`
    },
    copilotWidgetUrl: "https://copilot-dev.ai.localcblabs.com/widget.js",
    wsBaseUrl: "wss://wsapi-eu.revrec.devcb.in",
    reportsV2ApiUrl: "https://dev-eu-reports-v2.revrec.devcb.in/api"
};
